const jwtDecode = (jwt: string): any => {
    return JSON.parse(atob(jwt.split('.')[1]))
}

export default jwtDecode
